import { cn } from '@savvy-kit/lib/utils';

export function ShimmerLine({ className }: { readonly className?: string }) {
  return (
    <span
      aria-hidden="true"
      className={cn(
        'inline-block rounded-md bg-muted bg-no-repeat',
        'bg-[linear-gradient(90deg,transparent_0%,var(--color-card)_50%,transparent_100%)] bg-[length:200%_100%]',
        'animate-[progress-shimmer_1.4s_linear_infinite] motion-reduce:animate-none',
        className,
      )}
    />
  );
}
